import {
  API_ROUTES,
  API_ROUTE_PREFIX,
  IPageRequestParams,
  resolveCmpForApiRequest,
} from "@tm/api-utils";
import { CONTEXT, LOB, PARTNER } from "@tm/isomorphic-utils";
import {
  getLobOnServerSide,
  getPathPartnerOnServerSide,
} from "@tm/server-utils";
import { API_HTTP } from "../apiInstance";
import { setURLQueryParams } from "../setURLQueryParams";

export const getOrderListing = async (
  reqData: IPageRequestParams
): Promise<any> => {
  try {
    const { partner = PARTNER.MMT, headers, cmp, query, dvid } = reqData;
    const headerCmp = resolveCmpForApiRequest(cmp, query);
    const params = {
      lob: getLobOnServerSide(partner) || LOB.STANDALONE,
      context: CONTEXT.STANDALONE_V2,
      ins_new_flow: true,
      ...query,
    };
    const urlParams = setURLQueryParams(params);
    const pathPartner = getPathPartnerOnServerSide(partner);

    const response = await API_HTTP.get(
      `${API_ROUTE_PREFIX}/${pathPartner}/${API_ROUTES.ORDER_LISTING}${
        urlParams ? `?${urlParams}` : ""
      }`,
      {
        headers: { ...headers, cmp: headerCmp || "fallback", dvid },
      }
    );
    return response;
  } catch (error) {
    console.error("Error", { error });
    throw error;
  }
};
